// extracted by mini-css-extract-plugin
export default {"header":"Header_header__rYE4L","childrenButton":"Header_childrenButton__tuO8R","hiddenForMobile":"Header_hiddenForMobile__UTw3I","navigation":"Header_navigation__YfMH7"};